module.exports = __webpack_public_path__ + "media/food-site-idea-nuxt.e253430a.mp4";